import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, num } from "@/lib/api";
import { PageHeader, Card, Table, Sel, Money, StatusBadge } from "@/components/common";
import { useAuth } from "@/context/AuthContext";

export const VarianceTable = ({ loc }) => {
  const [rows, setRows] = useState([]);
  const nav = useNavigate();
  useEffect(() => { api.get("/variance", { params: loc ? { location_id: loc } : {} }).then((r) => setRows(r.data)); }, [loc]);
  const total = rows.reduce((s, r) => s + r.variance_value, 0);
  return (
    <>
      <div className="px-4 py-2 text-sm border-b">Total nilai variansi: <Money v={total} className="font-bold" /></div>
      <Table testid="variance-table" rows={rows} onRow={(r) => nav(`/opname/${r.opname_id}`)} cols={[
        { h: "Tanggal", k: "date" }, { h: "Opname", r: (r) => <span className="num text-xs">{r.opname_code}</span> }, { h: "Lokasi", k: "location_name" }, { h: "Barang", k: "item_name" },
        { h: "Expected", right: true, r: (r) => <span className="num">{num(r.expected_base)} {r.base_unit}</span> },
        { h: "Aktual", right: true, r: (r) => <span className="num">{num(r.actual_base)}</span> },
        { h: "Variansi qty", right: true, r: (r) => <span className={`num font-bold ${r.variance_base < 0 ? "text-rose-600" : ""}`}>{num(r.variance_base)}</span> },
        { h: "%", right: true, r: (r) => r.variance_pct == null ? "-" : `${num(r.variance_pct, 2)}%` },
        { h: "Nilai", right: true, r: (r) => <Money v={r.variance_value} className="font-semibold" /> },
        { h: "Catatan", k: "note" }, { h: "Status", r: (r) => <StatusBadge s={r.status} /> },
      ]} />
    </>
  );
};

export default function Variance() {
  const { myLocs } = useAuth();
  const [loc, setLoc] = useState("");
  return (
    <div>
      <PageHeader title="Variansi inventaris" sub="Expected (ledger: awal + terima + produksi − transfer − konsumsi teoritis ± penyesuaian) dibandingkan stok fisik dari opname.">
        <Sel testid="variance-location-filter" className="!w-56" value={loc} onChange={setLoc} placeholder="Semua lokasi" options={myLocs.map((l) => ({ value: l.id, label: l.name }))} />
      </PageHeader>
      <Card><VarianceTable loc={loc} /></Card>
    </div>
  );
}
